import { useIsMobile } from '/lib/state/core';

export const Backdrop: React.FC = () => {
  const [isMobile] = useIsMobile();

  return (
    <div className="backdrop" role="presentation">
      <style jsx>{`
        .backdrop {
          --backdrop-top: ${isMobile
            ? 'var(--banner-height, 0px)'
            : 'var(--header-height, 0px)'};

          background: linear-gradient(
            180deg,
            var(--backdrop) 0%,
            var(--backdrop-hidden) 100%
          );
          height: calc(100vh - var(--backdrop-top) - var(--tray-height, 0px));
          left: 0;
          pointer-events: none;
          position: fixed;
          top: var(--backdrop-top);
          width: 100vw;
        }
      `}</style>
    </div>
  );
};
